module.exports = __webpack_public_path__ + "img/S3.ddfc3900.png";